import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const InstitutionsPage = lazy(() => import('../pages/institutions/page'));
const InstitutionDetailPage = lazy(() => import('../pages/institution-detail/page'));
const UserDashboardPage = lazy(() => import('../pages/user-dashboard/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin-dashboard/page'));
const PlatformAdminPage = lazy(() => import('../pages/platform-admin/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const AraciKurumlarPage = lazy(() => import('../pages/araci-kurumlar/page'));
const TurkiyeHakkindaPage = lazy(() => import('../pages/turkiye-hakkinda/page'));
const TurkiyeKulturuPage = lazy(() => import('../pages/turkiye-kulturu/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const KvkkPage = lazy(() => import('../pages/kvkk/page'));
const WorkflowPage = lazy(() => import('../pages/workflow/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/saglik-kurumlari', element: <InstitutionsPage /> },
  { path: '/kurum/:id', element: <InstitutionDetailPage /> },
  { path: '/kullanici-paneli', element: <UserDashboardPage /> },
  { path: '/kurum-paneli', element: <AdminDashboardPage /> },
  { path: '/yonetici-paneli', element: <PlatformAdminPage /> },
  { path: '/iletisim', element: <ContactPage /> },
  { path: '/uye-ol', element: <RegisterPage /> },
  { path: '/araci-kurumlar', element: <AraciKurumlarPage /> },
  { path: '/turkiye-hakkinda', element: <TurkiyeHakkindaPage /> },
  { path: '/turkiye-kulturu', element: <TurkiyeKulturuPage /> },
  { path: '/kullanim-kosullari', element: <TermsPage /> },
  { path: '/gizlilik-politikasi', element: <PrivacyPage /> },
  { path: '/kvkk-aydinlatma-metni', element: <KvkkPage /> },
  { path: '/workflow', element: <WorkflowPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
